import type { View } from '@/store/app'

export interface ViewHistory { entries: View[]; index: number }
export function viewKey(view: View): string {
  return view.kind === 'guild' ? `guild:${view.guildId}:${view.channelId ?? ''}`
    : view.kind === 'home' ? 'channelId' in view ? `dm:${view.channelId}` : `home:${view.page}` : 'discovery'
}
export const initialHistory = (view: View): ViewHistory => ({ entries: [view], index: 0 })
/** Auto-selecting the first channel replaces the server placeholder, without another Back stop. */
export function pushView(history: ViewHistory, view: View, replace = false): ViewHistory {
  if (viewKey(history.entries[history.index]!) === viewKey(view)) return history
  if (replace) return { ...history, entries: history.entries.map((entry, i) => i === history.index ? view : entry) }
  const entries = [...history.entries.slice(0, history.index + 1), view].slice(-100)
  return { entries, index: entries.length - 1 }
}
export function moveView(history: ViewHistory, delta: -1 | 1): ViewHistory {
  const index = history.index + delta
  return index < 0 || index >= history.entries.length ? history : { ...history, index }
}
